
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 23 28"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke-width":"3","stroke":"currentColor","d":"M19.719 20.359c-.562.094-1.141.141-1.719.141-5.797 0-10.5-4.703-10.5-10.5 0-1.984.578-3.922 1.625-5.578A9.952 9.952 0 002 14c0 5.516 4.484 10 10 10 3.016 0 5.844-1.375 7.719-3.641z"}})])
          )
        }
      }
    